/**
 * Utilitaires pour la gestion des statuts des réclamations
 * Intégré avec le style de l'application
 */

// Couleurs principales de l'application
const appStyles = {
    primaryColor: '#F76707',   // Orange principal
    secondaryColor: '#0A6EBD', // Bleu principal
    lightOrange: '#FFF4E6',    // Orange clair
  };
  
  // Mapping des statuts et leurs propriétés (nom français, couleur)
  export const STATUS_MAP = {
    "created": {
      name: "Créée non affectée",
      colorCode: "#6c757d", // Gris
      description: "La réclamation est créée mais pas encore affectée"
    },
    "qualification": {
      name: "Qualification",
      colorCode: "#17a2b8", // Bleu ciel
      description: "Le pilote analyse la réclamation et décide de l'affecter pour la prise en charge"
    },
    "info_request": {
      name: "Demande d'informations",
      colorCode: "#ffc107", // Jaune
      description: "Le pilote demande des informations complémentaires"
    },
    "assigned": {
      name: "Affectée",
      colorCode: appStyles.secondaryColor, // Bleu principal
      description: "Le service traitant reçoit la réclamation et doit faire le nécessaire"
    },
    "to_validate": {
      name: "Traitée à valider",
      colorCode: appStyles.primaryColor, // Orange principal
      description: "Le Manager doit valider la prise en charge effective de la réclamation"
    },
    "validated": {
      name: "Validée",
      colorCode: "#28a745", // Vert
      description: "Réclamation validée par le manager"
    },
    "closed": {
      name: "Clôturée",
      colorCode: "#343a40", // Noir
      description: "Finalisation du dossier de réclamation après résolution"
    },
    "rejected": {
      name: "Rejetée",
      colorCode: "#dc3545", // Rouge
      description: "La réclamation a été rejetée"
    }
  };
  
  /**
   * Obtient le nom français d'un statut à partir de son code
   * @param {string} statusCode - Code du statut (ex: "created", "closed", etc.)
   * @returns {string} - Nom français du statut
   */
  export const getStatusName = (statusCode) => {
    return STATUS_MAP[statusCode]?.name || statusCode;
  };
  
  /**
   * Obtient le code couleur d'un statut à partir de son code
   * @param {string} statusCode - Code du statut
   * @returns {string} - Code couleur hexadécimal
   */
  export const getStatusColor = (statusCode) => {
    return STATUS_MAP[statusCode]?.colorCode || appStyles.primaryColor; // Couleur par défaut
  };
  
  /**
   * Obtient la description d'un statut à partir de son code
   * @param {string} statusCode - Code du statut
   * @returns {string} - Description du statut
   */
  export const getStatusDescription = (statusCode) => {
    return STATUS_MAP[statusCode]?.description || "Statut inconnu";
  };
  
  /**
   * Génère le style CSS pour un badge de statut
   * @param {string} statusCode - Code du statut
   * @returns {Object} - Objet de style React
   */
  export const getStatusBadgeStyle = (statusCode) => {
    const colorCode = getStatusColor(statusCode);
    
    // Pour les couleurs claires (jaune, orange), utiliser du texte foncé
    const textColor = ["#ffc107", "#fd7e14"].includes(colorCode) ? "#212529" : "#ffffff";
    
    return {
      backgroundColor: colorCode,
      color: textColor,
      padding: "0.5rem 1rem",
      fontWeight: "bold",
      borderRadius: "0.25rem",
      display: "inline-block",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    };
  };
  
  /**
   * Génère le style CSS pour une alerte de statut (version étendue avec description)
   * @param {string} statusCode - Code du statut
   * @returns {Object} - Objet de style React
   */
  export const getStatusAlertStyle = (statusCode) => {
    const colorCode = getStatusColor(statusCode);
    
    // Pour les couleurs claires (jaune, orange), utiliser du texte foncé
    const textColor = ["#ffc107", "#fd7e14"].includes(colorCode) ? "#212529" : "#ffffff";
    
    return {
      backgroundColor: colorCode,
      color: textColor,
      borderColor: colorCode,
      borderLeft: `5px solid ${colorCode}`,
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      padding: "1rem",
      borderRadius: "0.25rem"
    };
  };